/* global jQuery COMPONENTS google properties markerIcons MarkerClusterer googleMapsStyler useClustering */

COMPONENTS.ComponentMap = (function ($) {
  function ComponentMap () {
    if (typeof properties === 'undefined') {
      return
    }

    this.$component = $('[data-ecs-component="component-assetmap"]')

    if (this.$component.length < 1) {
      // There is no asset map component on the page, bail out
      return
    }

    this.utility = new COMPONENTS.Utility()
    this.$map = $('[data-ecs-components-control="map"]')
    this.$list = $('[data-ecs-components-control="assetmap-list"]')
    this.$mapTab = $('[data-ecs-components-map-toggle="map"]')
    this.$listTab = $('[data-ecs-components-map-toggle="list"]')
    this.$propertyCards = $('[data-ecs-components-control="assetmap-property"]')
    this.$filterControls = $('[data-ecs-components-control="status-map-filter"]')
    this.$clearControl = $('[data-ecs-components-control="status-map-clear"]')
    this.mapElem = this.$map.get(0)
    this.propertyData = properties
    this.markerIcons = markerIcons
    this.useClustering = useClustering

    this.map = null
    this.markers = []
    this.bounds = null
    this.markerCluster = null

    this.mapArgs = {
      scrollwheel: false,
      maxZoom: 20,
      minZoom: 4,
      disableDefaultUI: true,
      zoomControl: false,
      cameraControl: true,
      streetViewControl: true,
      gestureHandling: 'cooperative'
    }

    if (typeof googleMapsStyler !== 'undefined') {
      this.mapArgs.styles = googleMapsStyler
    }
  }

  ComponentMap.prototype.initUI = function () {
    if (!this.mapElem) return

    const component = this

    component.$mapTab.click(function () {
      component.$map.show()
      component.$list.hide()
    })

    component.$listTab.click(function () {
      component.$map.hide()
      component.$list.show()
    })

    component.bindCards()

    component.bindLegend()

    component.bindClear()

    this.$list.isotope({
      itemSelector: '[data-ecs-components-control="assetmap-property"]'
    })
  }

  ComponentMap.prototype.initMap = function () {
    if (!this.mapElem) return
    this.map = new google.maps.Map(this.mapElem, this.mapArgs)
    this.addMarkers()
  }

  ComponentMap.prototype.addMarkers = function (_activeProperty = 0, _data = this.propertyData) {
    if (!this.map) return
    const component = this
    this.bounds = new google.maps.LatLngBounds()

    for (var i = 0; i < _data.length; i++) {
      const markerItem = {}
      const propertyLatLng = new google.maps.LatLng(_data[i].location.lat, _data[i].location.lng)
      markerItem.title = _data[i].name
      markerItem.propertyLatLng = propertyLatLng
      markerItem.map = this.map
      markerItem.property = _data[i].id
      markerItem.status = _data[i].status.slug

      let markerToUse = this.markerIcons.default

      if (_data[i].status.marker) {
        markerToUse = _data[i].status.marker
      }

      if (parseInt(_activeProperty) === parseInt(markerItem.property)) {
        markerToUse = this.markerIcons.active
      }

      const marker = new google.maps.Marker({
        property: markerItem.property,
        position: markerItem.propertyLatLng,
        title: markerItem.title,
        icon: markerToUse,
        map: markerItem.map
      })

      this.bounds.extend(marker.position)
      this.markers.push(marker)
      this.bindMarker(marker)
    }

    if (_activeProperty > 0) {
      const active = this.markers.filter(function (_marker) {
        return _marker.property === _activeProperty
      })

      this.map.setZoom(18)
      this.map.panTo(active[0].position)
    } else {
      this.map.fitBounds(this.bounds)

      if (this.useClustering) {
        this.markerCluster = new MarkerClusterer(this.map, this.markers, { maxZoom: 17, styles: [{ url: this.markerIcons.cluster, width: 64, height: 64, textColor: '#ffffff', textSize: 14 }] })

        google.maps.event.addListener(this.markerCluster, 'clusterclick', function (cluster) {
          let clusterFilter = ''
          const selectedMarkers = cluster.getMarkers()
          const ids = component.utility.arrayColumn(selectedMarkers, 'property')
          ids.forEach(function (i, idx, array) {
            clusterFilter += '.pid' + i
            if (idx !== array.length - 1) {
              clusterFilter += ', '
            }
          })
          component.$list.isotope({ filter: clusterFilter })
        })
      }
    }
  }

  ComponentMap.prototype.clearMarkers = function () {
    for (var m = 0; m < this.markers.length; m++) {
      this.markers[m].setMap(null)
    }
    this.markers = []

    if (this.useClustering) {
      this.markerCluster.clearMarkers()
    }
  }

  ComponentMap.prototype.bindMarker = function (_marker) {
    const component = this
    const $listItem = $(`[data-ecs-components-property="${_marker.property}"]`)

    google.maps.event.addListener(_marker, 'click', function () {
      $('[data-ecs-components-property]').removeClass('components__active')
      $listItem.trigger('click')
      const filter = `.pid${$listItem.data('ecs-components-property')}`
      component.$list.isotope({ filter: filter })
      // component.$list.scrollTo($listItem)
      $listItem.addClass('components__active')
    })
  }

  ComponentMap.prototype.bindCards = function () {
    const component = this
    if (typeof this.$propertyCards === 'undefined') {
      return
    }

    this.$propertyCards.each(function () {
      const $card = $(this)

      $card.click(function () {
        if ($card.hasClass('components__active')) {
          $card.removeClass('components__active')
          component.clearMarkers()
          component.addMarkers()
          component.$list.isotope({ filter: '*' })
        } else {
          const propertyID = $card.data('ecs-components-property')
          component.$propertyCards.each(function () {
            $(this).removeClass('components__active')
          })
          $card.addClass('components__active')
          component.clearMarkers()
          component.addMarkers(propertyID)
        }
      })
    })
  }

  ComponentMap.prototype.bindLegend = function () {
    const component = this
    if (typeof this.$filterControls === 'undefined') {
      return
    }

    component.$filterControls.each(function () {
      const $control = $(this)
      $control.click(function () {
        const status = $control.data('ecs-components-status')

        const filteredMarkers = component.propertyData.filter(function (property) {
          return property.status.slug === status.replace('.', '')
        })

        component.clearMarkers()
        component.addMarkers(0, filteredMarkers)
        component.$list.isotope({ filter: status })
      })
    })
  }

  ComponentMap.prototype.bindClear = function () {
    const component = this
    component.$clearControl.click(function () {
      component.clearMarkers()
      component.addMarkers()
      component.$list.isotope({ filter: '*' })
    })
  }

  return ComponentMap
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.componentMap = new COMPONENTS.ComponentMap()
  COMPONENTS.componentMap.initUI()

  if (window._ecsGoogleMapsLoaded) {
    COMPONENTS.componentMap.initMap()
  } else {
    document.addEventListener('ecs_googlemaps_ready', function () {
      COMPONENTS.componentMap.initMap()
    }, { once: true })
  }
})
